/* eslint-disable camelcase */
import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { TaskGeneralIcon, TaskSubformIcon } from "shared/icons"
import { monthDate } from "utils/dateHelpers"
import rawHtmlToReact from "services/rawHtmlToReact"
import { capitalize } from "utils/stringHelpers"
import { activityHubSubmissionAndTaskPath, redirectTo } from "utils/routeHelpers"

const TaskResult = ({ result }) => {
  const {
    id, formSubmissionSlug, title, subform, es_highlight, dueDate,
  } = result
  const [[field, highlight]] = Object.entries(es_highlight)

  const taskSubformTitle = subform?.title ?? "General Task"

  const redirectToTask = () => {
    redirectTo(activityHubSubmissionAndTaskPath(formSubmissionSlug, id))
  }

  return (
    <div
      className={clsx(
        "border border-light-300 bg-white",
        "rounded-lg p-3 mb-2 text-sm cursor-pointer",
        "flex justify-between space-x-3",
      )}
      onClickCapture={redirectToTask}
    >
      {
        subform ? (
          <TaskSubformIcon className="h-8 w-8" />
        ) : (
          <TaskGeneralIcon className="h-8 w-8" />
        )
      }
      <div className="flex-grow">
        <div className="font-semibold text-normal">
          { `${capitalize(field)}` }
        </div>
        <div className="mt-1">
          { rawHtmlToReact(highlight) }
        </div>
        <div className="font-semibold tracking-tight text-dark">
          { title }
          <span className="text-dark text-lg opacity-60 align-middle">
            { " > " }
          </span>
          { taskSubformTitle }
        </div>
      </div>
      <div className="text-dark font-medium">
        { monthDate(dueDate) }
      </div>
    </div>
  )
}

TaskResult.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  result: types.object.isRequired,
}

export default TaskResult
